import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {
    DimensionGuides,
    GuideParameters,
    unitForDisplayOptions,
    BoundsEdge,
    BoundsEdgeDimension,
    boundsEdgeDirectionToIndex,
    boundsEdgeNumbers,
} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-dimension-guides-inspector",
    standalone: true,
    templateUrl: "./dimension-guides-inspector.component.html",
    styleUrl: "./dimension-guides-inspector.component.scss",
    imports: [ValueSlotComponent],
})
export class DimensionGuidesInspectorComponent extends BaseInspectorComponent<DimensionGuides> {
    readonly $edgeOptions = computed<SelectionPossibilities<BoundsEdge>>(() => {
        return [
            {
                name: `Closest edge`,
                value: "auto",
            },
            ...boundsEdgeNumbers.map((value) => ({
                name: `Edge ${value}`,
                value,
            })),
        ]
    })

    readonly $unitOptions = computed<SelectionPossibilities<string>>(() => {
        const result = unitForDisplayOptions.map((opt) => ({
            name: opt,
            value: opt,
        }))

        return result
    })

    changedEdge(direction: BoundsEdgeDimension) {
        const node = this.$node()
        const guide: GuideParameters = node.parameters.guides[boundsEdgeDirectionToIndex(direction)]

        node.updateParameters({
            ...node.parameters,
            [`guide${direction.toUpperCase()}`]: guide,
        })
    }
}
